import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';

import useDialog from 'hooks/useDialog';

import { isNumber } from 'lib/number';
import { removeHashFromUrl } from 'lib/request';

import { useCouponDeepLink } from 'providers/CouponDeepLinkProvider';

const PickCouponDialog = dynamic(
  () => import('components/Coupons/PickCouponDialog'),
  { ssr: false }
);

const COUPON_HASH_PREFIX = '#cupom:';
// Wait for CouponListItem to mount before opening the picker
const DELAY_MS = 250;

const CouponDeepLinkHandler = () => {
  const router = useRouter();
  const { showDialog } = useDialog();
  const { revealCouponCodes } = useCouponDeepLink();

  const handleCouponHash = useCallback(() => {
    const { hash } = window.location;

    if (!hash?.startsWith(COUPON_HASH_PREFIX)) {
      return;
    }

    const couponId = Number(hash.split(':')[1]);

    if (!isNumber(couponId) || couponId <= 0) {
      return;
    }

    revealCouponCodes();

    setTimeout(() => {
      showDialog(PickCouponDialog, {
        couponId,
        sourceType: 'deep_link',
        sourceValue: 'direct_url',
      });
    }, DELAY_MS);

    removeHashFromUrl(router);
  }, [revealCouponCodes, router, showDialog]);

  // Handle hash on initial page load
  useEffect(() => {
    handleCouponHash();
  }, [handleCouponHash]);

  // Handle hash on client-side navigations (e.g. Mercado Livre shallow push)
  useEffect(() => {
    router.events.on('routeChangeComplete', handleCouponHash);

    return () => {
      router.events.off('routeChangeComplete', handleCouponHash);
    };
  }, [handleCouponHash, router.events]);

  return null;
};

export default CouponDeepLinkHandler;
